/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const CAMBIUM_LICENSE_KEYS_URL = `${API_URL}/cambium`;
